import { MotionReveal } from '@/components/common/MotionReveal';
import { SectionTitle } from '@/components/common/SectionTitle';

const cards = [
  {
    title: 'Misija',
    description: 'Da kompanijama pomognemo da važne projekte organizuju realno, vode pregledno i završe u dogovorenom obimu.'
  },
  {
    title: 'Vizija',
    description: 'Da izgradimo dugoročna partnerstva sa organizacijama kojima je potrebna pouzdana podrška tokom rasta i promena.'
  }
];

export function MissionVisionSection() {
  return (
    <section className="border-y border-border bg-surface-muted py-18 sm:py-24 lg:py-28">
      <div className="site-container grid gap-10 lg:grid-cols-[0.65fr_1.35fr] lg:gap-20">
        <SectionTitle eyebrow="Usmerenje" title="Šta želimo da postignemo u radu sa klijentima." />
        <div className="grid gap-4 md:grid-cols-2">
          {cards.map((card, index) => (
            <MotionReveal key={card.title} delay={index * 0.06} className="h-full">
              <article className={`h-full p-7 sm:p-8 ${index === 0 ? 'bg-primary-soft' : 'bg-surface'}`}>
                <h3 className="text-2xl font-semibold tracking-[-0.03em] text-text-primary">{card.title}</h3>
                <p className="mt-4 text-base leading-7 text-text-secondary">{card.description}</p>
              </article>
            </MotionReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
